import "./WydarzeniaContainer.css"
import Icon from "../Icons/Icon"
import { NavLink } from "react-router-dom"
import { useState } from "react";
import { deleteEventByID, getApiErrorMessage } from "../../../api/api";
import { formatDate } from "../../../utils/formatDate";
import { getResponsiveImageVariables } from "../../../utils/imagePosition";

const DEFAULT_IMAGE = '/uploads/events/default.jpg';

export default function WydarzeniaContainer({ id, title, description, date, image, imagePosition, imagePositionMobile, hex = {}}) {
    const imageUrl = image ? `/uploads/events/${image}` : DEFAULT_IMAGE;
    const [isVisible, setIsVisible] = useState(true)

    const baseStyle = {
        pointerEvents: 'none',
        userSelect: 'none',
        ...getResponsiveImageVariables(imagePosition, imagePositionMobile),
    };

    const deleteEvent = async (id) => {
        const isConfirmed = window.confirm('Czy na pewno chcesz usunąć to wydarzenie?');

        if (!isConfirmed) {
            return;
        }

        try {
            const response = await deleteEventByID(id)
            setIsVisible(false)
            if ((response?.data?.cleanup_warnings || 0) > 0) {
                alert('Wydarzenie usunięto z bazy, ale niektórych plików nie udało się usunąć. Sprawdź log serwera.');
            }
        } catch (error) {
            console.error('Błąd usuwania:', error);
            alert(`❌ ${getApiErrorMessage(error, 'Wystąpił błąd podczas usuwania!')}`);
        }
    };

    return (
        <div className="inline-pen event-card-shell" style={{ display: isVisible ? 'flex' : 'none' }}>
            <div className="container" style={{ borderColor: hex.secondary, '--event-background': hex?.background || '#290401' }}>
                <div className="bg">
                    <div 
                        className="gradient-overlay"
                        style={{ background: `linear-gradient(to right, ${hex?.background || "#290401"} 31%, rgba(0, 0, 0, 0) 100%)` }}
                    ></div>
                    <img
                        src={imageUrl}
                        alt={title || 'Wydarzenie'}
                        style={baseStyle}
                        className="event-positioned-image"
                        draggable={false}
                        onError={(event) => {
                            if (event.currentTarget.src.endsWith(DEFAULT_IMAGE)) return;
                            event.currentTarget.src = DEFAULT_IMAGE;
                        }}
                    />
                </div>
                <div className="content">
                    <h1 style={{ color: hex.primary }}>{title || 'Bez tytułu'}</h1>
                    <h4 style={{ color: hex.primary }}>{description || 'Brak opisu'}</h4>

                    <div className="bottom-container">
                        <NavLink to={"/view-event/" + id}>
                            <button style={{ borderColor: hex.secondary, color: hex.secondary }}>Zobacz więcej</button>
                        </NavLink>
                        <div className="vertical-line" style={{ backgroundColor: hex.secondary }}></div>
                        <div className="date-block">
                            <Icon name={"calendar"} width={30} color={ hex?.secondary || "#F9C49A" } />
                            <span style={{ color: hex?.secondary || "#F9C49A" }}>{formatDate(date) || 'Brak daty'}</span>
                        </div>
                    </div>
                </div>
            </div>
            { localStorage.getItem("isAdmin") === 'true' ? 
            <div className="event-container-horizontal-button">
                <NavLink to={"/edit-event/" + id}>
                    <div className="pen-block">
                        <Icon name={"pen"} />
                    </div>
                </NavLink>
                <div className="pen-block" onClick={ () => deleteEvent(id) }>
                    <Icon name={"trash"} />
                </div>
            </div> :
            ""
            }
        </div>
    )
}
